import { useQuery } from "@tanstack/react-query";
import { getAlertSettings } from "../api/alertSettings";
import type { AlertSettings } from "@hp/api-client";

/** The org-wide settings (Settings pages), read once and shared by every hook that needs one of them: the key, the fetch and the
 * fallback live here only, so the forms' setQueryData calls and every reader agree. */
export function useAlertSettings() {
  return useQuery({ queryKey: ["alert-settings"], queryFn: () => getAlertSettings() });
}

/** One setting's value, or undefined until the settings have loaded (or when they cannot be). */
export function useAlertSetting<K extends keyof AlertSettings>(key: K): AlertSettings[K] | undefined {
  const settings = useAlertSettings();
  return settings.data ? settings.data[key] : undefined;
}
